import logo from './logo.svg';
import './App.css';
import React, {useState} from 'react';

import { ReportCreationtPanel } from './components/layout/ReportCreationPanel/ReportCreationPanel'



function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ReportCreationtPanel/>
      </header>



    </div>
  );
}

export default App;
